<template>
  <section>
    <!-- Componentes externos -->
    <ReprogramarCronograma />
    <VerDetalle />
    <h4 class="primary--text">
      <v-icon color="primary">people</v-icon>
      <p>Vacaciones programadas {{ this.$route.params.gestion }}</p>
    </h4>
    <v-card>
      <v-card-text v-if="!!estado_vacacion">
        <DatosPersonalesProgramacion
          :id_estado_vacacion="estado_vacacion.id"
          v-model="total_dias_programar"
        />
      </v-card-text>
      <v-card-text class="text-xs-center py-1">
        <v-card color="indigo" class="px-3 white--text ">
          <span class="caption">NÚMERO DE DÍAS RESTANTES A PROGRAMAR</span
          ><br />
          <span class="display-1">{{
            total_dias_programar - total_dias_programados
          }}</span>
        </v-card>
      </v-card-text>
      <v-card-text>
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>

              <div class="filter-item">
                <v-text-field
                  label="Nro papeleta"
                  v-model="form.secuencia"
                  @input="filterSecuencia"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha salida"
                  v-model="form.ap_paterno"
                  @input="filterFechaDesde"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha fin"
                  v-model="form.fecha_hasta"
                  @input="filterFechaHasta"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Dias"
                  v-model="form.total_dias"
                  @input="filterTotalDias"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Estado"
                  v-model="form.estado"
                  @input="filterEstado"
                ></v-text-field>
              </div>
              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                        recargar();
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="l_programaciones"
          hide-actions
          :search="filters"
          :custom-filter="customFilter"
        >
          <template v-slot:items="items">
            <td class="text-xs-center">{{ items.item.secuencia }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_desde).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_hasta).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.total_dias }}</td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
          </template>
          <template v-slot:footer>
            <td colspan="3" class="footer-table">
              <strong>{{ `Total dias programados` }}</strong>
            </td>
            <td class="text-xs-center title">
              <strong>{{ total_dias_programados }}</strong>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import ReprogramarCronograma from "./dialogs/ReprogramarCronograma.vue";

import VerDetalle from "../vacaciones/dialogs/Ver";
import DatosPersonalesProgramacion from "../vacaciones/components/DatosPersonalesProgramacion.vue";
import filtrosProgramacion from "../vacaciones/mixins/filtrosProgramacion";
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [filtrosProgramacion],
  // Variables iniciales del componente
  data() {
    return {
      nombre: null,
      fecha_ingreso: null,
      nro_doc: null,
      nro_item: null,
      graphql: true,
      funcionario: [],
      gestion: this.$route.params.gestion,
      id_persona: parseInt(this.$route.params.id_persona),
      total_dias_programar: null,
      estado_vacacion: null,
      // Variables de la tabla
      l_programaciones: [],
      headers: [
        { text: "Nro de papeleta", value: "secuencia", align: "center" },
        { text: "Fecha inicio", value: "fecha_desde", align: "center" },
        { text: "Fecha fin", value: "fecha_hasta", align: "center" },
        { text: "Días", value: "total_dias", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
      ],
      // Variables filtros
      filterShow: true,
      filters: {
        secuencia: "",
        fecha_desde: "",
        fecha_hasta: "",
        total_dias: "",
        estado: ""
      },
      form: {}
    };
  },
  computed: {
    total_dias_programados() {
      return this.l_programaciones.reduce((accumulator, current) => {
        // Excluimos registros anulados
        return (
          accumulator +
          ([9, 83].includes(current.id_estado) ? 0 : current.total_dias)
        );
      }, 0);
    }
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarProgramaciones();
    // Cargamos datos del estado vacacion
    this.estado_vacacion = await this.$query.select(
      "v_estado_vacacion",
      { id_persona: this.id_persona, periodo: this.gestion },
      ["id_persona", "periodo", "id_programacion", "id"]
    );
    this.estado_vacacion = this.estado_vacacion[0];
    this.$bus.$on("closeDialogVerReporteCronograma", async () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionario", () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioNormal", () => {});
    this.$bus.$on("closeDialogSolicitarUsoVacacionFuncionario", async () => {
      await this.cargarProgramaciones();
    });
    this.$bus.$on("closeDialogReprogramacion", async () => {
      await this.cargarProgramaciones();
    });
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para cargar el listado de programaciones
    async cargarProgramaciones() {
      let l_tmp = await this.$query.select(
        "v_vaca_programada",
        { id_persona: this.id_persona, gestion: this.gestion },
        [
          "id",
          "id_persona",
          "id_estado",
          "fecha_desde",
          "fecha_hasta",
          "fecha_solicitud",
          "total_dias",
          "gestion",
          "estado",
          "saldo_a_reprogramar",
          "secuencia"
        ]
      );
      // Arreglamos formatos de fechas
      l_tmp.forEach(element => {
        element.fecha_desde = this.$moment(
          element.fecha_desde,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        element.fecha_hasta = this.$moment(
          element.fecha_hasta,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
      });
      this.l_programaciones = l_tmp;
    },

    verReporte(item, valor) {
      //   item.reprogramacion = valor; //programacion=0,repro=1
      //   this.$bus.$emit("openDialogVerReporte", item);
    },

    reprogramarCronograma(item) {
      this.$bus.$emit("openDialogReprogramarCronograma", item);
    },
    verDetalle(item) {
      item.funcionario = this.funcionario;
      // item.saldo = this.saldo;
      this.$bus.$emit("openDialogVer", item);
      // this.$bus.$emit("openDialogVerDetalleUsoFuncionarioNormal", item);
    }
  },
  // Definición de componentes importados
  components: {
    ReprogramarCronograma,
    DatosPersonalesProgramacion,
    VerDetalle
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/ProgramacionesPorFuncionario.vue